<template>
    <a ref="email"></a>
</template>

<script>
    import EmailObfuscate from 'email-obfuscate';
    export default {
        props: ['name', 'domain', 'tld'],
        mounted() {
            EmailObfuscate(this.$refs.email, {
                // Email construct: name@domain.tld
                name: this.name,
                domain: this.domain ? this.domain : 'orbitalfasteners',
                tld: this.tld ? this.tld : 'co.uk',
            });
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/EmailLink.vue